/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { ResetterService } from '../../resetter/resetter.service';

@Injectable({
  providedIn: 'root'
})
export class ResetActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'reset';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private resetter: ResetterService
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    this.resetter.reset();
  }

  // Private Functions
}
